import { createFieldRenderer } from 'forms';
import classNames from 'classnames';
import React from 'react';

/**
 * Renders a field as a cell in a table
 */
const TableCellRenderer = createFieldRenderer(({
    className = '',
    error = null,
    factory,
    innerClassName = '',
    label,
    ...props
}) => <td
        className={classNames(
            className,
            'table-row-cells-field-cell',
            `field-renderer-${props.name}`,
            { 'has-error': !!error }
        )}>
    {factory({
        ...props,
        className: classNames(innerClassName),
    })}
</td>);

export default TableCellRenderer;
